
    ;(function () {
      const gtmId = import.meta.env.VITE_GTM_ID

      if (!gtmId) return

      const ns = document.createElement('noscript')
      ns.innerHTML = `
              <iframe
                src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
                height="0"
                width="0"
                style="display:none;visibility:hidden"
              ></iframe>`
      document.body.insertBefore(ns, document.body.firstChild)
    })()
  